export default __webpack_public_path__ + "app/images/theme-images/dark/ic-edit/icon-20-edit@2x.webp";